export default __webpack_public_path__ + "static/media/blog-post-layout-02-img-03.b5c2c33e.jpg";